import React from "react";

const UpdateChat = ({ formData, handleChange, handleSubmit, onCancel, loading, error }) => {
  return (
    <div className="p-6 max-w-lg mx-auto bg-white shadow rounded">
      <h2 className="text-2xl font-bold mb-4">Update Chat Information</h2>

      {/* Display Loading State */}
      {loading && <p className="text-blue-500 mb-4">Updating...</p>}

      {/* Display Error Message */}
      {error && <p className="text-red-500 mb-4">{error}</p>}

      <form onSubmit={handleSubmit}>
        {/* Slug */}
        <div className="mb-4">
          <label className="block text-gray-700">Slug:</label>
          <input
            name="slug"
            value={formData.slug}
            onChange={handleChange}
            className="border w-full p-2"
            placeholder="Enter slug"
          />
        </div>

        {/* Name */}
        <div className="mb-4">
          <label className="block text-gray-700">Name:</label>
          <input
            name="name"
            value={formData.name}
            onChange={handleChange}
            className="border w-full p-2"
            placeholder="Enter name"
            required
          />
        </div>

        {/* Email */}
        <div className="mb-4">
          <label className="block text-gray-700">Email:</label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            className="border w-full p-2"
            placeholder="Enter email"
          />
        </div>

        {/* WhatsApp */}
        <div className="mb-4">
          <label className="block text-gray-700">WhatsApp:</label>
          <input
            type="text"
            name="whatsapp"
            value={formData.whatsapp}
            onChange={handleChange}
            className="border w-full p-2"
            placeholder="Enter WhatsApp number"
          />
        </div>

        {/* Message */}
        <div className="mb-4">
          <label className="block text-gray-700">Message:</label>
          <textarea
            name="message"
            value={formData.message}
            onChange={handleChange}
            className="border w-full p-2"
            placeholder="Enter message"
          ></textarea>
        </div>

        {/* Message Time */}
        <div className="mb-4">
          <label className="block text-gray-700">Message Time:</label>
          <input
            type="number"
            name="messageTime"
            value={formData.messageTime}
            onChange={handleChange}
            className="border w-full p-2"
          />
        </div>

        {/* Submit Button */}
           <div className="flex justify-end space-x-3">
             <button
              type="button"
              onClick={onCancel}
              className="bg-gray-500 text-white px-6 py-2 rounded hover:bg-gray-600"
              disabled={loading}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
              disabled={loading}
            >
              {loading ? "Updating..." : "Update Chat"}
            </button>
        </div>
      
      </form>
    </div>
  );
};

export default UpdateChat;
